import { render, staticRenderFns } from "./IssueCertificate.vue?vue&type=template&id=e7990a10&"
import script from "./IssueCertificate.vue?vue&type=script&lang=js&"
export * from "./IssueCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports